export const initialPlaces = [
  {
    title: "Plaza 24 de Septiembre, Santa Cruz Bolivia",
    coords: [-17.7834936, -63.1820853],
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ea, eveniet?",
  },
  {
    title: "Plaza Murillo, La Paz Bolivia",
    coords: [-16.4957409, -68.1334839],
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ea, eveniet?",
  },
  {
    title: "Copacabana, La Paz Bolivia",
    coords: [-16.1629986, -69.0899133],
    description:
      "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Ea, eveniet?",
  },
];
